import React, { useState, useEffect } from 'react';

function Onboarding() {
  const [phase, setPhase] = useState(0); // 0: NVC quote, 1: Welcome message

  useEffect(() => {
    // Phase 0: NVC quote - 4 seconds
    const timer1 = setTimeout(() => setPhase(1), 4000);
    
    // Phase 1: Welcome - stays until user closes
    
    return () => {
      clearTimeout(timer1);
    };
  }, []);

  const nvcQuotes = [
    "Your presence is the most precious gift you can give to another human being.",
    "When we focus on clarifying what is being observed, felt, and needed, we discover the depth of our own compassion.",
    "Empathy is a respectful understanding of what others are experiencing.",
    "All violence is a tragic expression of unmet needs."
  ];

  const randomQuote = nvcQuotes[Math.floor(Math.random() * nvcQuotes.length)];

  return (
    <div 
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        backgroundImage: `url('https://customer-assets.emergentagent.com/job_nvc-workbook/artifacts/nepvm2p0_IMG_2412.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Content */}
      <div className="relative z-10 max-w-4xl px-6 text-center">
        {/* Phase 0: NVC Quote */}
        <div 
          className={`transition-opacity duration-1000 ${phase === 0 ? 'opacity-100' : 'opacity-0 absolute inset-0'}`}
        >
          <div 
            className="p-12 mx-auto"
            style={{
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '58% 42% 48% 52% / 62% 45% 55% 38%',
              maxWidth: '800px'
            }}
          >
            <p className="text-3xl md:text-4xl font-serif italic leading-relaxed text-gray-800" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              {randomQuote}
            </p>
            <p className="text-lg mt-4 text-gray-600">— Marshall Rosenberg</p>
          </div>
        </div>

        {/* Phase 1: Welcome + Next Steps */}
        <div 
          className={`relative z-20 transition-opacity duration-1000 ${phase === 1 ? 'opacity-100' : 'opacity-0'}`}
        >
          <div 
            className="p-12 mx-auto"
            style={{
              background: 'rgba(255, 255, 255, 0.98)',
              borderRadius: '45% 55% 52% 48% / 58% 47% 53% 42%',
              maxWidth: '700px',
              zIndex: 100
            }}
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-center" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              Welcome to<br/>The Belonging Sessions
            </h1>
            <div className="space-y-4 text-xl text-gray-700 text-center">
              <p className="font-semibold">Thank you for registering!</p>
              <p>We will be in touch soon with session details.</p>
              <p className="text-lg text-gray-600">
                You will receive account access information later, including login credentials and access to additional resources.
              </p>
            </div>
            <div className="mt-8 text-center">
              <a href="/">
                <button className="bg-black text-white hover:bg-black/90 px-8 py-4 text-lg font-bold">
                  Return to Home
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        
        @keyframes spiralPulse {
          0%, 100% {
            transform: scale(1) rotate(0deg);
            opacity: 0.3;
          }
          25% {
            transform: scale(1.05) rotate(2deg);
            opacity: 0.4;
          }
          50% {
            transform: scale(1.02) rotate(-2deg);
            opacity: 0.35;
          }
          75% {
            transform: scale(1.08) rotate(1deg);
            opacity: 0.45;
          }
        }
      `}</style>
    </div>
  );
}

export default Onboarding;
